import { AppDefinitionId, ViewerClientSpecMap } from '@wix/thunderbolt-symbols'
import { PresetsDataList, WidgetsToPresets } from './types'

const getPresetUrl = ({
	csm,
	appDefinitionId,
	presetId,
	builderAppDefinitionIds,
}: {
	csm: ViewerClientSpecMap
	appDefinitionId: AppDefinitionId
	widgetId: string
	presetId: string
	builderAppDefinitionIds: Record<string, string>
}) => {
	const decodedUrl = decodeURI(builderAppDefinitionIds[appDefinitionId] || '')
	const appData =
		csm[appDefinitionId] || Object.values(csm).filter((app) => app.appDefinitionId === appDefinitionId)[0]
	const componentBaseUrl = appData?.appFields?.platform?.baseUrls?.componentBaseUrl || decodedUrl
	// || (appData?.widgets[widgetId]?.componentModel?.componentUrl as string)

	return `${componentBaseUrl}${presetId}.css`
}

export const getBuilderPresets = (
	presets: PresetsDataList,
	csm: ViewerClientSpecMap,
	builderAppDefinitionIds: Record<string, string>
) => {
	return presets.reduce((widgetsToPresets: WidgetsToPresets, { appDefinitionId, widgetId, presetId }) => {
		widgetsToPresets[widgetId] = widgetsToPresets[widgetId] || {}
		widgetsToPresets[widgetId][presetId] = getPresetUrl({
			csm,
			builderAppDefinitionIds,
			appDefinitionId,
			widgetId,
			presetId,
		})
		return widgetsToPresets
	}, {})
}
